export const CPD_LOCALSTORAGE_KEY = 'cpdModalDontShowAgainTimestamp';

/**
 * По требованиям мы не должны показывать баннер ранее, чем через 30 дней,
 * если пользователь явно запретил нам это делать.
 */
export const CPD_DONT_SHOW_TIME_SPAN = 30 * 24 * 60 * 60 * 1000;
